module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/008-c12b3ed865bd851ba75c8b7f72c5fe50.jpg";